import { IconButton, Tooltip } from '@ds';
import { MdKeyboardArrowDown, MdKeyboardArrowRight, MdOutlineWifiTethering } from 'react-icons/md';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { ConditionalRender } from '@ui';
import { ShareInChat } from '@icons';

type LogItemHeaderProps = {
  event: string;
  onShareClick?: () => void;
  onOpenChange?: () => void;
  isOpen?: boolean;
  sharedIndicatorIcon?: boolean;
  sharedVariant?: 'base' | 'light';
  startContent?: ReactNode;
  endContent?: ReactNode;
  cssStyleBySize?: Record<string, string | number>;
};

export const LogItemHeader = ({
  event = 'Event',
  isOpen,
  sharedIndicatorIcon,
  sharedVariant = 'base',
  startContent,
  endContent,
  cssStyleBySize,
  onShareClick,
  onOpenChange,
}: LogItemHeaderProps) => (
  <div className="flex gap-2 items-center justify-between">
    <div className="flex flex-wrap flex-1 gap-1 items-center">
      <ConditionalRender show={!!startContent}>{startContent}</ConditionalRender>
      <ConditionalRender show={sharedIndicatorIcon}>
        <MdOutlineWifiTethering size={18} className={clsx({ 'text-white': sharedVariant === 'light' })} />
      </ConditionalRender>
      <div
        className={clsx('flex-1 w-10', cssStyleBySize?.labelClassNames || 'text-s-m', {
          'text-white': sharedVariant === 'light',
        })}
      >
        {event}
      </div>
      <ConditionalRender show={!!endContent}>
        <div className="flex shrink-0 items-center">{endContent}</div>
      </ConditionalRender>
    </div>
    <ConditionalRender show={!!onOpenChange}>
      <IconButton
        onPress={onOpenChange}
        className="bg-base-55 h-5 w-5 transition"
        variant="light"
        disableRipple
        startContent={isOpen ? <MdKeyboardArrowRight /> : <MdKeyboardArrowDown />}
      />
    </ConditionalRender>
    <ConditionalRender show={!!onShareClick}>
      <Tooltip content="Discuss in chat" placement="top" showArrow>
        <IconButton
          onPress={onShareClick}
          className="bg-base-5 text-white hover:bg-white hover:text-base-5 h-5 w-5 transition"
          variant="light"
          disableRipple
          startContent={<ShareInChat />}
          aria-label="Share log"
        />
      </Tooltip>
    </ConditionalRender>
  </div>
);
